import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-lmiv-product-skeleton',
  imports: [
    MatCardModule,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './lmiv-product-skeleton.component.html',
  styleUrl: './lmiv-product-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LmivProductSkeletonComponent {
}
